import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { useFunFactsQuery } from '../actions/apiSlice';
import { skipToken } from '@reduxjs/toolkit/query/react';

function FunFacts({ show }) {
  const { data: funFacts, isFetching, isError } = useFunFactsQuery(
    show ? { name: show.title, year: show.year, kind: show.kind } : skipToken,
  );

  if (!show || !show.title || !show.year) {
    return <Typography color="text.secondary">Show details missing.</Typography>;
  }

  if (isFetching) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return <Typography color="text.secondary">Couldn't load fun facts.</Typography>;
  }

  return (
    <Box>
      <Stack spacing={1.5} sx={{ mb: 2 }}>
        {funFacts?.facts?.map((fact, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'flex-start',
              p: 1.5,
              borderRadius: 2,
              bgcolor: (t) =>
                t.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
              border: (t) => `1px solid ${t.palette.divider}`,
            }}
          >
            <LightbulbIcon sx={{ color: 'primary.main', mt: 0.25 }} fontSize="small" />
            <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
              {fact}
            </Typography>
          </Box>
        ))}
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        powered by Gemini AI
        <Box
          component="img"
          src="https://upload.wikimedia.org/wikipedia/commons/f/f0/Google_Bard_logo.svg"
          alt="Gemini"
          sx={{ width: 14, height: 14 }}
        />
      </Typography>
    </Box>
  );
}

export default FunFacts;
